module.exports = __webpack_public_path__ + "img/logo.847e07f7.svg";